import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "break-inside-avoid" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Реквізити")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ФОП Федічкін Олександр Володимирович")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 70101, Запорізька обл. Запорізький район")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" c.Новомиколаївка вул. Українська 48в")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ПАТ КБ \"ПриватБанк\"")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ЄДРПОУ 2618708351")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("р/р ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" UA093052990000026005010210480")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("МФО 305299")


export default /*#__PURE__*/_defineComponent({
  __name: 'Creds',
  props: {
    hideTitle: { type: Boolean },
    hideBank: { type: Boolean },
    showIbanLabel: { type: Boolean },
    showMfo: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hideTitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    (!__props.hideBank)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_12,
          _hoisted_13
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_14,
    _hoisted_15,
    (__props.showIbanLabel)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_16
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_17,
    _hoisted_18,
    (__props.showMfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_19
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})